import { useEffect, useLayoutEffect } from 'react'
import { useLocation, useNavigate, useNavigationType, useParams } from 'react-router-dom'

// Posiciones de scroll guardadas por entrada de historial (location.key).
// Vive fuera del componente porque ScrollToTop se monta una sola vez.
const scrollPositions = {}

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
      />
    );
  }

  return ComponentWithRouterProp;
}

function ScrollToTop({ navigate, setCurrentLocation, setOffset }) {
  // Guarda la url actual
  const location = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    setCurrentLocation(location.pathname)
  }, [location, setCurrentLocation]);

  // Guarda continuamente el scroll de la entrada de historial actual
  useEffect(() => {
    const handleScroll = () => { scrollPositions[location.key] = window.scrollY }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [location.key]);

  // POP (atrás/adelante del navegador): restaura el scroll guardado.
  // PUSH/REPLACE (navegación hacia adelante): resetea a top, como siempre.
  useLayoutEffect(() => {
    const target = navigationType === 'POP' ? (scrollPositions[location.key] ?? 0) : 0
    window.scrollTo(0, target);
  }, [location, navigationType]);

  return (null)
}

export default withRouter(ScrollToTop)